// Client-side Sentry/Replay is intentionally disabled for the public marketing
// pages. Loading Replay globally adds a large JavaScript chunk to every page.
// Server-side request/error capture remains configured in `src/instrumentation.ts`.
export {};
